import React from "react";
import TrackVisibility from "react-on-screen";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "Satish",
  avatarImage: "/images/avatar-2.svg",
  content:
    "I am Satish Suthar, web developer from Melbourne, Australia. I have rich experience developing Web and Apps development, I have designed and developed cloud native and serverless applications.",
};

const progressData = [
  {
    id: 1,
    title: "Full Stack .Net Development",
    percantage: 85,
    progressColor: "#FFD15C",
  },
  {
    id: 2,
    title: "Cloud - AWS & Azure",
    percantage: 75,
    progressColor: "#FF4C60",
  },
  {
    id: 3,
    title: "Front End - Angular, React, Blazor",
    percantage: 65,
    progressColor: "#6C6CE5",
  },
];

const counterData = [
  {
    id: 1,
    title: "Years of experience",
    count: 17,
    icon: "icon-fire",
  },
  {
    id: 2,
    title: "Projects",
    count: 100,
    icon: "icon-cup",
  },
  {
    id: 3,
    title: "Years of team leading",
    count: 7,
    icon: "icon-people",
  },
  {
    id: 4,
    title: "Years of cloud",
    count: 6,
    icon: "icon-cloud-upload",
  },
];

function About() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Me" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <div className="mt-3">
                    <a href="!#" className="btn btn-default">
                      Download CV
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
        <div className="row fix-spacing">
          {counterData.map((counter) => (
            <div key={counter.id} className="col-md-3 col-sm-6">
              <TrackVisibility once>
                <Counter counterItem={counter} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
